/**
 * Public Footer
 *
 * One footer for the landing and legal pages; the blog renders the same links.
 * Legal links point to public /legal/* pages for Shopify App Store compliance.
 */

import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { LEGAL_ROUTES } from '@/config/public-links'
import { usePublicHrefs } from './usePublicHrefs'

export function Footer() {
  const { t } = useTranslation()
  const hrefs = usePublicHrefs()
  // A year is a label, not a quantity: a string skips the i18n number formatter's grouping.
  const currentYear = String(new Date().getFullYear())

  const links = [
    { label: t('landing:footer.links.guide'), href: hrefs.guide },
    { label: t('landing:footer.links.updates'), href: hrefs.updates },
    { label: t('landing:footer.links.sources'), href: hrefs.sources },
    { label: t('landing:footer.links.privacy'), href: LEGAL_ROUTES.privacy, isRoute: true },
    { label: t('landing:footer.links.terms'), href: LEGAL_ROUTES.terms, isRoute: true },
    { label: t('landing:footer.links.rss'), href: hrefs.rss },
  ]

  return (
    <footer className="border-t" style={{ borderColor: 'var(--lp-rule)' }}>
      <div className="mx-auto w-full max-w-6xl px-6 py-8 lg:px-10">
        <div className="flex flex-col items-start justify-between gap-5 sm:flex-row sm:items-center">
          <p className="text-sm" style={{ color: 'var(--lp-meta)' }}>
            {t('landing:footer.copyright', { year: currentYear })}
          </p>

          <nav aria-label="Footer" className="flex flex-wrap items-center gap-x-7 gap-y-3">
            {links.map((link) =>
              link.isRoute ? (
                <Link
                  key={link.href}
                  to={link.href}
                  className="lp-nav-link whitespace-nowrap text-sm transition-colors"
                  style={{ color: 'var(--lp-body)' }}
                >
                  {link.label}
                </Link>
              ) : (
                <a
                  key={link.href}
                  href={link.href}
                  className="lp-nav-link whitespace-nowrap text-sm transition-colors"
                  style={{ color: 'var(--lp-body)' }}
                >
                  {link.label}
                </a>
              ),
            )}
          </nav>
        </div>
      </div>
    </footer>
  )
}
